import KendoTreeView from './KendoTreeView'
import KendoTreeViewItem from './KendoTreeView/KendoTreeViewItem'
import KendoTreeViewInstaller from './kendo-treeview-installer'

export {
    KendoTreeView, KendoTreeView as TreeView, KendoTreeViewItem, KendoTreeViewItem as TreeViewItem, KendoTreeViewInstaller, KendoTreeViewInstaller as TreeViewInstaller
}


// WEBPACK FOOTER //
// ./packages/kendo-treeview-vue-wrapper/src/index.js